<template>
  <div class="new_sidebar">
    <div class="new_sidebar_head">
      目录
      <span class="tagbar_icon" @click="addTreeItem">
        <i class="el-icon-plus"></i>
      </span>
      <!--      <el-popover popper-class="zl_sidebar_popper" placement="bottom" width="100" trigger="click">-->
      <!--        <div class="zl_sidebar_popper_btn" style="user-select: none">-->
      <!--          <p class="popper_p" @click="addTreeItem">-->
      <!--            <img src="../../../static/images/newCourseImages/tianjia@2x.png" alt="添加节点" />-->
      <!--            <span>添加节点</span>-->
      <!--          </p>-->
      <!--          &lt;!&ndash; 0节点，1素材，2作业，3习题，5测验，6图文，7图片，8文档, 9音频，10视频 &ndash;&gt;-->
      <!--        </div>-->
      <!--        <i-->
      <!--          slot="reference"-->
      <!--          class="el-icon-circle-plus-outline"-->
      <!--          style="float: right;cursor: pointer"-->
      <!--        ></i>-->
      <!--      </el-popover>-->
    </div>

    <el-tree
      :data="treeData"
      node-key="id"
      :style="{ height }"
      :props="defaultProps"
      @node-click="handleNodeClick"
      ref="tree"
      :highlight-current="true"
      :default-expanded-keys="[defaultExpansion]"
      :draggable="openDraggable"
      :allow-drop="allowDrop"
      @node-drop="handleDrop"
    >
      <div
        class="custom-tree-node"
        slot-scope="{ node, data }"
        @mouseover.passive="treeMouseOver($event, data)"
        @mouseleave.passive="treemouseLeave()"
        @dblclick="edit(data)"
      >
        <span
          class="custom-tree-node-label"
          v-if="data.id && data.status != 1"
          :title="data.catalogName"
        >{{data.catalogName}}</span>

        <el-input
          class="nodeInput"
          v-if="data.status == 1"
          style="width: 90%; margin-right: 20px"
          v-model="data.catalogName"
          size="small"
          placeholder="添加目录"
          :ref="'edit' + data.id"
          @blur="blurEdit(data)"
          @keyup.enter.native="enterBlur($event, data)"
          maxlength="100"
        ></el-input>

        <span v-if="iconIsShow == data.id">
          <el-popover
            popper-class="zl_sidebar_popper1"
            placement="bottom"
            width="118"
            trigger="click"
          >
            <div class="zl_sidebar_popper_btn" style="user-select: none">
              <p
                class="popper_p"
                v-if=" data.resourceBase && !data.resourceBase.length && (data.level === 1 || data.level === 2) && (data.isAddChild === 1)"
                @click="append(node, data, 0)"
              >
                <!-- <img src="../../../static/images/newCourseImages/tianjia@2x.png" alt="添加目录" /> -->
                <i class="el-icon-circle-plus-outline"></i>
                <span>子目录</span>
              </p>
              <p
                class="popper_p"
                v-if="data.catalogParentId && data.children &&  !data.children.length && (data.isAddChild === 1)"
                @click="addPage(data)"
              >
                <!-- <img src="../../../static/images/newCourseImages/tianjia@2x.png" alt="添加页面" /> -->
                <i class="el-icon-circle-plus-outline"></i>
                <span>{{newName}}</span>
              </p>
              <p class="popper_p" @click="edit(data)">
                <!-- <img src="../../../static/images/newCourseImages/zh@2x.png" alt="编辑节点" /> -->
                <i class="el-icon-edit-outline"></i>
                <span>编辑</span>
              </p>
              <p class="popper_p" @click="remove(node, data)">
                <!-- <img src="../../../static/images/newCourseImages/sc@2x(1).png" alt="删除节点" /> -->
                <i class="el-icon-delete"></i>
                <span>删除</span>
              </p>
            </div>

            <span
              @click.stop="openSelectType"
              slot="reference"
              v-if="data.id"
              class="el-icon-more catalogedtordel"
              :class="{'tree-node-block': iconIsShow == data.id && data.status != 1}"
            ></span>
          </el-popover>
        </span>
      </div>
    </el-tree>
  </div>
</template>

<script>
import * as api from "../../api/courseApi";
import bus from "../../bus/bus.js";
/**
 *        新课程目录树，可修改新增，拖拽
 *              -- Author by wjl. on 2021.7.2
 */
export default {
  name: "new_sidebar",
  props: {
    courseId: {
      type: [String, Number],
      default: 0,
    },
    subjectId: {
      type: [String, Number],
      default: 0,
    },
    newName: {
      type: String,
      default: '页面'
    }
  },
  data() {
    return {
      menuType: this.$route.query.menuType, //课程类型 ，2单项 3综合
      treeData: [],
      defaultExpansion: 0, //默认展开的目录
      activeOne: {},
      height: window.innerHeight / 1.4 + "px",
      defaultProps: {
        //目录配置
        children: "children",
        label: "catalogName",
      },
      // 2021.7.6
      popover_visible: false,
      iconIsShow: -1,
      // 2021.7.12
      oldCatalogName: "",
      openDraggable: true,
    };
  },
  created() {
    this.getCourseCatalog();
    // console.log(this.$route)
    bus.$on("businit", this.getCourseCatalog);
  },
  beforeDestroy() {
    bus.$off("businit");
    // sessionStorage.removeItem("new_sidebar_default");
  },
  methods: {

    getCourseCatalog() {
      //获取课程目录
      api
        .newGetCourseCatalog(this.courseId, this.menuType)
        .then((res) => {
          if (res.code == 0) {
            if (res.data && res.data.length) {
              this.openDraggable = true;  // 目录树，开启拖拽功能，在修改时禁用
              this.treeData = res.data;
              let defualt = sessionStorage.getItem("new_sidebar_default");
              if (defualt) {
                this.defualtOne(JSON.parse(defualt));
              } else {
                this.$nextTick(() => {
                  // 默认高亮选中节点
                  if (
                    this.treeData[0].children &&
                    this.treeData[0].children.length
                  ) {
                    if (
                      this.treeData[0].children[0].children &&
                      this.treeData[0].children[0].children.length
                    ) {
                      this.defualtOne(this.treeData[0].children[0].children[0]);
                    } else {
                      this.defualtOne(this.treeData[0].children[0]);
                    }
                  }
                });
              }
            } else {
              this.treeData = [];
              this.$emit("emptyCatalogue");
            }
          } else {
            this.$messageError(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    defualtOne(data) {
      this.defaultExpansion = data.id;
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.defaultExpansion);
        let newData = this.$refs.tree.getCurrentNode();
        this.handleNodeClick(newData);
      });
    },
    handleNodeClick(data) {
      if(data == null || !data.catalogName) return;
      this.$emit("clearCatalogName", data.catalogName);
      this.activeOne = data;
      let defualtopt = sessionStorage.getItem("new_sidebar_default");
      if (defualtopt) {
        let opt = JSON.parse(defualtopt);
        if (opt.id && opt.id === data.id && opt.tagIndex > 0) {
          sessionStorage.setItem(
            "new_sidebar_default",
            JSON.stringify({ id: data.id, tagIndex: opt.tagIndex})
          );
        } else {
          sessionStorage.setItem(
            "new_sidebar_default",
            JSON.stringify({ id: data.id })
          );
        }
      } else {
        sessionStorage.setItem(
          "new_sidebar_default",
          JSON.stringify({ id: data.id })
        );
      }

      //点击课程目录
      this.$emit("handleTreeNodeClick", data);
    },
    // *  type 1素材，2作业，3习题，5测验，6图文，7图片，8文档, 9音频，10视频
    // 添加一级目录（章节）
    addTreeItem() {
      this.resertTree(this.treeData);
      var obj = {
        catalogName: "",
        catalogParentId: 0,
        id: "",
        status: 1,
        courseId: this.courseId,
        catalogType: this.menuType,
      };
      this.treeData.push({ ...obj });
      this.edit({ ...obj });
    },
    // 编辑节点
    edit(data) {
      this.openDraggable = false;
      this.$set(data, "status", 1);
      if (data.catalogName) {
        this.oldCatalogName = data.catalogName;
      }
      this.$nextTick(() => {
        let that = this;
        let timer = setTimeout(() => {
          that.$refs["edit" + data.id].$refs.input.focus();
          clearTimeout(timer);
        }, 30);
      });
    },
    openSelectType() {
      this.popover_visible = true;
    },
    // 新增子目录
    append(node, data, type) {
      //  7图片，8文档, 9音频，10视频
      this.iconIsShow = -1;
      this.popover_visible = false;
      this.resertTree(this.treeData);
      this.defaultExpansion = 0;

      let obj = {
        id: "",
        type, // 素材分类
        // catalogType: type, // 素材分类
        status: 1,
        catalogName: "",
        catalogParentId: data.id,
        courseId: this.courseId,
        catalogType: this.menuType,
      };
      data.children.push({ ...obj });
      this.edit({ id: "" });
      this.defaultExpansion = data.id;
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(data.id);
      });
    },

    allowDrop(draggingNode, dropNode, type){
      // 不能拖拽有子级的目录
      if (draggingNode.data.children && draggingNode.data.children.length){
        // console.log('--allowDrop--', type, draggingNode.data,dropNode.data )
        if (type== 'prev' || type== 'next'){
          if (draggingNode.data.catalogParentId === dropNode.data.catalogParentId){
            return type
          }
        }
      }else if (type === 'inner'){
        if (dropNode.data.resourceBase && dropNode.data.resourceBase.length ){
          // 不能给添加了素材的目录插入子级
          return false;
        }else if (dropNode.level == 3){
          // 不能给第三级目录插入子级
          return false;
        }else{
          return type
        }
      }else{
        if (draggingNode.data.resourceBase && draggingNode.data.resourceBase.length && dropNode.level == 1) {
          return false;
        }else{
          return type
        }
      }
    },
    // 目录节点拖拽完成
    handleDrop(before, after, inner) {
      // if (before.data.catalogParentId != after.data.catalogParentId) return;
      let level = 0;
      if (inner == "before") {
        level = 0;
      } else if (inner == "inner") {
        level = 1;
      } else if (inner == "after") {
        level = 2;
      }
      // 拖拽成功完成时触发的事件
      let obj = {
        catalogId: before.data.id,
        courseId: this.courseId,
        professionId: this.professionId,
        level: level,
        targetId: after.data.id,
        // catalogSort:0
      };
      api
        .handleDrop(obj)
        .then(() => {
          this.getCourseCatalog();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 编辑tree input 失去焦点
    blurEdit(data) {
      if (data.catalogName == "" || this.oldCatalogName == data.catalogName) {
        this.$set(data, "status", 0);
        // 空的不保存不提示没反应
        if(data.catalogName == '' && this.oldCatalogName != ''){
          data.catalogName = this.oldCatalogName
        }
        this.resertTree(this.treeData);
        return;
      }
      this.defaultExpansion = 0;
      if (data.id) {
        let obj = {
          id:data.id,
          catalogName:data.catalogName
        }
        api
          .editCatalogSave(obj)
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("修改成功");
              this.defaultExpansion = data.id;
              this.getCourseCatalog();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        api
          .addCatalog(data, { method: "post" })
          .then((res) => {
            bus.$emit("businit");
            if (res.code == "0") {
              this.$message.success("添加成功");
              this.defaultExpansion = res.data.id;
              this.activeOne = res.data;
              sessionStorage.setItem(
                "new_sidebar_default",
                JSON.stringify({ id: res.data.id })
              );
              this.getCourseCatalog();
              this.$set(data, "status", 0);
              // 如果有type,是添加素材目录，并添加素材
              if (data.type == 6) {
                this.addImageText(res.data, data);
              } else if (data.type) {
                this.addResourse(res.data, data);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //  保存图文内容
    addImageText(catalog, data) {
      let params = {
        subjectId: this.subjectId,
        name: data.catalogName,
        imageText: data.resourceId,
      };
      api.postAddImageText(params).then((res) => {
        if (res.code == 0) {
          let param = {
            courseId: data.courseId,
            type: data.type,
            resourceId: res.data.id,
          };
          this.addResourse(catalog, param);
        }
      });
    },
    // 给目录绑定资源
    addResourse(catalog, data) {
      let resourse = {
        catalogId: catalog.id,
        courseId: data.courseId,
        list: [
          {
            catalogId: catalog.id,
            courseId: data.courseId,
            resourceId: data.resourceId,
            type: data.type,
          },
        ],
      };
      api
        .postAddMaterialOne(resourse)
        .then((res) => {
          if (res.code == "0") {
            this.$emit("handleTreeNodeClick", catalog);
            this.$message.success("保存成功");
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addPage(data) {
      this.$emit("handleTreeNodeClick", data);
      setTimeout(()=>{
        sessionStorage.setItem(
          "new_sidebar_default",
          JSON.stringify({ id: data.id })
        );
        this.$emit("handleTreeNodeClick", data,'add');
        // sessionStorage.setItem(
        //   "new_sidebar_default",
        //   JSON.stringify({ id: data.id })
        // );
        this.popover_visible = false;
        this.iconIsShow = -1;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(data.id);
        });
      },200)

    },
    enterBlur(event, data) {
      if (data.catalogName == "") {
        this.$message.warning("目录名称不得为空");
      }
      event.target.blur(data);
      // this.getCourseCatalog();
    },
    //删除节点
    remove(node, data, resourse) {
      if (data.children && data.children.length !== 0) {
        this.$message.warning("此节点有子节点不可删除");
      } else {
        this.$confirm("是否删除该节点?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (data.resourceBase && data.resourceBase.length > 0) {
              // 如果目录下有资源，则先删除资源，再删除目录
              if (resourse) {
                this.removeResourse(data, resourse);
              } else {
                this.removeResourse(data, data.resourceBase[0]);
              }
            } else {
              // 目录下没有资源，删除目录
              this.removeCatalog(data);
            }
            if(sessionStorage.getItem('new_sidebar_default')){
              if(data.id == JSON.parse(sessionStorage.getItem('new_sidebar_default')).id){
                sessionStorage.removeItem('new_sidebar_default')
              }
            }
          })
          .catch(() => {});
      }
    },
    // 删除目录下的素材
    removeResourse(data, resourse) {
      let daleteResourse = {
        catalogId: data.id,
        courseId: this.courseId,
        list: [resourse.id],
      };
      api
        .batchDeleteSource(daleteResourse)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("删除素材成功");
            this.$emit("clearCatalogName", "");
            this.removeCatalog(data);
          } else if (res.code == "1") {
            this.$message.warning(res.msg);
          } else {
            this.$message.error("系统错误");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 删除目录
    removeCatalog(data) {
      api
        .deleteCatalog(data.id)
        .then((res) => {
          if (res.code == "0") {
            this.defaultExpansion = data.catalogParentId;
            this.getCourseCatalog();
            this.$emit("setStatus", 0);
            this.$message.success("删除目录成功");
            this.$emit("clearCatalogName", "");
          } else if (res.code == "1") {
            this.$message.warning(res.msg);
          } else {
            this.$message.error("系统错误");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 手动刷新tree数据。空id的都清除掉
    resertTree(arr) {
      [].forEach.call(arr, (item, index) => {
        if (!item.id) arr.splice(index, 1);
        if (item.children && item.children.length) {
          this.resertTree(item.children);
        }
      });
      this.openDraggable = true;
    },
    // 鼠标移入移出事件
    treeMouseOver(e, data) {
      if (data.isResoures) return;
      this.iconIsShow = data.id;
    },
    treemouseLeave() {
      if (!this.popover_visible) {
        this.iconIsShow = -1;
      }
      this.popover_visible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.new_sidebar {
  height: 100%;
  min-width: 200px;
  overflow: auto;
  .new_sidebar_head {
    padding: 15px 10px;
    font-weight: 600;
    font-size: 15px;
    border-bottom: 1px solid #D2D2D7;
    margin-bottom: 20px;
    .tagbar_icon {
      width: 16px;
      height: 16px;
      line-height: 18px;
      text-align: center;
      font-size: 12px;
      color: #42414d;
      border: 1px solid #595964;
      float: right;
      cursor: pointer;
      transform: scale(0.9);
      font-weight: 600;
      border-radius: 2px;
      &:hover {
        color: #409eff;
        border: 1px solid #409eff;
      }
    }
  }
  /deep/ .el-tree {
    background: #ffffff;
    margin: 0 10px;
  }
  /deep/ .el-tree-node__content {
    height: 32px;
    border-radius: 5px;
    &:hover {
      background: rgba(24, 144, 255, 0.09);
      .custom-tree-node {
        color: rgba(24, 144, 255, 1) !important;
      }
    }
    .custom-tree-node {
      padding-right: 8px;
      width: 100%;
      color: #42414d;
      height: 32px;
      line-height: 32px;
      display: flex;
      justify-content: space-between;
      /*font-size: 15px;*/
      position: relative;
      .custom-tree-node-label {
        display: inline-block;
        width: 145px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
    }
    .catalogedtordel {
      display: inline-block;
      margin-right: 4px;
      transform: rotate(90deg);
    }
    .el-icon-circle-plus-outline {
      margin: 0 3px;
      display: none;
      line-height: 32px;
      font-size: 15px;
    }
    .selectType {
      width: 120px;
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 5000;
    }
  }
  /deep/ .el-tree-node__children .el-tree-node__content {
    // background: #f6f6f6;
    // margin-bottom: 4px;
    .custom-tree-node {
      color: #2b2a33;
    }
    &:hover {
      background: rgba(24, 144, 255, 0.09);
      .custom-tree-node {
        color: rgba(24, 144, 255, 1) !important;
      }
    }
  }
  /deep/ .el-tree-node__children {
    .el-tree-node__content {
      // margin-left: 10px;
      padding-left: 10px !important;
    }
    .el-tree-node__children {
      .el-tree-node__content {
        // margin-left: 20px;
        padding-left: 20px !important;
      }
      .el-tree-node__children {
        .el-tree-node__content {
          // margin-left: 30px;
          padding-left: 30px !important;
        }
      }
    }
  }
  /deep/
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    &:hover {
      background: rgba(24, 144, 255, 0.09);
    }
  }
  /deep/
    .el-tree--highlight-current
    .el-tree-node__children
    .el-tree-node.is-current
    > .el-tree-node__content {
    .custom-tree-node {
      color: #42414d;
    }
  }
  .tree-node-block {
    display: inline-block !important;
  }
}
.popper_p {
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  color: #595964;
  &:hover {
    background: rgba(245, 245, 247, 1);
  }
  // img {
  //   margin-right: 10px;
  //   width: 14px;
  //   height: 14px;
  // }
  i{
    margin-right: 10px;
    font-size: 14px;
  }
  span{
    display: inline-block;
    width: 36px;
  }
}
</style>
<style>
.zl_sidebar_popper1 {
  width: 118px;
  box-sizing: border-box;
  min-width: 118px !important;
  padding: 0px;
  margin-top: 6px;
}
.el-tree-node:focus > .el-tree-node__content {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/component/new_sidebar.vue